/**
 * Reiter-Leiste beider Liefertermin-Tools: "Import" | "Lieferverzug".
 *
 * Einmal hier, damit die beiden Tools nicht auseinanderlaufen. Der aktive
 * Reiter traegt die CI-Gelb-Unterkante (Marke, keine Datenfarbe) und dunkle
 * Schrift — nie helle Schrift auf Gelb.
 */

import { FARBEN } from './viz';

export type LieferterminReiter = 'import' | 'verzug';

export function ReiterLeiste({
  aktiv, aufWechsel,
}: { aktiv: LieferterminReiter; aufWechsel: (r: LieferterminReiter) => void }) {
  const reiter: Array<{ key: LieferterminReiter; label: string }> = [
    { key: 'import', label: 'Import' },
    { key: 'verzug', label: 'Lieferverzug' },
  ];

  return (
    <div style={{
      display: 'flex', gap: '0.25rem', marginBottom: '1.25rem',
      borderBottom: `1px solid ${FARBEN.linie}`,
    }}>
      {reiter.map((r) => {
        const an = r.key === aktiv;
        return (
          <button
            key={r.key}
            onClick={() => aufWechsel(r.key)}
            style={{
              padding: '0.55rem 0.9rem', fontSize: '0.9375rem', cursor: 'pointer',
              background: 'none', border: 'none', marginBottom: '-1px',
              borderBottom: `3px solid ${an ? FARBEN.akzent : 'transparent'}`,
              color: an ? FARBEN.tinteStark : FARBEN.tinteMittel,
              fontWeight: an ? 650 : 400,
            }}
          >
            {r.label}
          </button>
        );
      })}
    </div>
  );
}

export default ReiterLeiste;
